module.exports = __webpack_public_path__ + "img/issues.7607dafc.svg";